<template>
  <div>
    <my-header></my-header>
    <div class="home">
      <div class="homebg"></div>
      <div class="main">
        <div class="mainbox" :class="{'en-width':isEn}">
          <div class="mobile">
            <img src="https://static.lespark.cn/pc_img/images/mobile_shell.png">
            <swiper :autoPlay='true'
                    :showIndicator='false'
                    interval="2500"
                    duration="500"
                    @transtionend="getNum">
              <slide class='slide'>
                <img :src="baiHuaImg"
                     alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile1.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/live.png"
                   alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile2.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/video_v2.png"
                     alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile3.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/nearby.png"
                     alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile4.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/couple.png"
                     alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile5.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/voiceChat.png"
                     alt="">
              </slide>
              <slide class='slide'>
                <img v-if="!isEn" src="https://static.lespark.cn/pc_img/images/mobile6.png"
                     alt="">
                <img v-else src="https://static.lespark.cn/pc_img/images/baihua/match_v2.png"
                     alt="">
              </slide>
            </swiper>
          </div>
          <div class="main-slogan" :class="{'main-slogan-en':isEn}">
            <h1 class="kouhao" :class="{'en-size':isEn}">
              {{h1Content}}
            </h1>
            <h2 class='kouhao-2'>{{h2Content}}</h2>
            <h2 class='kouhao-3'>
              <span><a target='_blank'
                   href="/les-app.html">{{$t('home.appProfile')}}</a></span>
              <span style="margin-left: 30px"><a target='_blank'
                       href="/baihua.html">{{ $t('header.baihuaTitle') }}</a></span>
            </h2>
            <div class="download">
              <!-- 苹果 -->
              <a :href="u_key=='lestory_cn'?url.ios_url:url_2.ios_url">
                <div class="down"
                     @mouseenter="enter(0)"
                     @mouseleave="leave()">
                  <img class="icon"
                       src="https://static.lespark.cn/pc_img/images/apple.png">
                  <div class="word">{{$t('home.download1')}}</div>
                </div>
              </a>
              <!-- 安卓 -->
              <a :href="u_key=='lestory_cn'?url.android_url:url_2.android_url">
                <div class="down"
                     @mouseenter="enter(1)"
                     @mouseleave="leave()">
                  <img class="icon"
                       src="https://static.lespark.cn/pc_img/images/android.png">
                  <div class="word">{{$t('home.download2')}}</div>
                </div>
              </a>
              <!-- 谷歌 -->
              <a :href="u_key=='lestory_cn'?url.google_url:url_2.google_url">
                <div class="down"
                     @mouseenter="enter(2)"
                     @mouseleave="leave()">
                  <img class="icon"
                       src="https://static.lespark.cn/pc_img/images/Google.png">
                  <div class="word">{{$t('home.download3')}}</div>
                </div>
              </a>
            </div>
            <div class="qr_code">
<!--              <div v-show='showList[0]'><img src="https://static.lespark.cn/pc_img/images/ios_qrcode.png"-->
<!--                     alt=""></div>-->
<!--              <div v-show='showList[1]'><img src="https://static.lespark.cn/pc_img/images/andr_qrcode.png"-->
<!--                     alt=""></div>-->
<!--              <div v-show='showList[2]'> <img src="https://static.lespark.cn/pc_img/images/google_qrcode.png"-->
<!--                     alt=""></div>-->
              <div v-show='showList[url_index]' v-for="url,url_index in url_code[u_key]">
                <img :src="url" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 话题 -->
    <topic></topic>

    <!-- 关注 -->
    <attention></attention>

    <!-- 热门 -->
    <hot></hot>

    <!-- 照片墙 -->
    <photowall></photowall>
    <!-- 底部 -->
    <my-footer></my-footer>
  </div>
</template>

<script>
  import Vue from "vue";
  import cookie from 'Common/cookie';
  import constans from 'Constans';
  import "babel-polyfill";
  import promise from "es6-promise";
  import util from 'Common/util';
  import ajax from 'Common/ajax';
  import bus from 'Common/events-bus';
  import VueMeta from 'vue-meta'
  import { Swiper, Slide } from 'vue-swiper-component';
  import 'Views/css/home/mess.css';
  import myHeader from 'Views/components/header'
  import myFooter from 'Views/components/foot'
  import hot from 'Views/components/hot'
  import attention from 'Views/components/attention'
  import topic from 'Views/components/topic'
  import photowall from 'Views/components/photowall'
  import { Loading, Icon, Button, MessageBox, Row, Col, Input, Select, Option } from "element-ui";
  const DOMAIN = constans.APIS.domain
  const userUrl = constans.AllUrl.url.dev
  Vue.use(VueMeta)
  export default {
    name: 'mess',
    components: {
      hot: hot,
      attention: attention,
      topic: topic,
      myHeader: myHeader,
      myFooter: myFooter,
      Swiper,
      Slide,
      photowall,
    },
    data() {
      return {
        attentionMsg: '',
        showList: [false, false, false],
        url: {
          'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
          'google_url': "https://play.google.com/store/apps/details?id=com.redwolfama.peonylespark.gp",
          'ios_url': "https://itunes.apple.com/cn/app/id1329843362?mt=8",
          'qr_img_url': "https://img2.lespark.cn/web/ewm.png",
        },
        title: '',
        description: '',
        h1Content: '',
        h2Content: '',
        canonical: 'https://www.lespark.cn',
        baiHuaImg:'',
        isEn:false,
        url_code:{
          lespark_us:[
            'https://static.lespark.cn/pc_img/oversea_qr_code.png',
            'https://static.lespark.cn/pc_img/images/andr_qrcode.png',
            'https://static.lespark.cn/pc_img/oversea_qr_code.png',
          ],
          lestory_cn:[
            'https://static.lespark.cn/pc_img/images/ios_qrcode.png',
            'https://static.lespark.cn/pc_img/images/andr_qrcode.png',
            'https://static.lespark.cn/pc_img/images/google_qrcode.png',
          ],
        },
        u_key:'lestory_cn',
        url_2:{
          'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
          'google_url': "https://lespark.onelink.me/DPjM/bi0y8b09",
          'ios_url': "https://lespark.onelink.me/sRtA/2saczuub",
        }
      }
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [
          { name: 'description', content: this.description },
        ],
        link: [
          {
            ref: "canonical",
            href: this.canonical
          },
        ]
      }
    },
    mounted() {
      var that = this;
      bus.$on('url', function (msg) {
        let url = {}
        url = msg
        if (url != '') {
          that.url = msg
        }
      })
      bus.$on('attentionShow', function (msg) {
        that.attentionMsg = msg
      })
      this.h1Content = this.$t('swiper')[0].h1Content
      this.h2Content = this.$t('swiper')[0].h2Content
    },
    beforeCreat() {
    },
    created() {
      var that = this
      if(window.location.host.includes('lespark.us')){
        that.u_key = 'lespark_us'
      }else{
        that.u_key = 'lestory_cn'
      }
      var language = cookie.getCookie('language') != '' ? cookie.getCookie('language') : '简体中文'
      if(util.getLang() == 'cn'){
        this.title = 'LesPark-纯女性交友社区 - LesPark'
        this.description = 'LesPark是女性专属交友泛娱乐平台，在这里遇见与你相同的她。全新推出的灵魂匹配、视频匹配和多人连麦功能，让交友更快捷。每日推送新鲜资讯和同好圈内容，有趣好玩的短视频等你来观看，动态八卦直播让你不错过每一个与她相关的点滴。'
      }else if(util.getLang() == 'en'){
        this.title = 'LesPark-The best APP for lesbians,queer and bisexual women'
        this.description = "LesPark, with 10 million female users, is the world's most popular dating and entertainment app for women. The 'Love Park' has a private love zone for lesbian couples. 'Chat room' supports multi-person chat. Daily updates on LGBT content, short videos, posts and live streams to keep you entertained."
      }else{
        this.title = 'LesPark-純女性交友社區 - LesPark'
        this.description = 'LesPark是女性專屬交友泛娛樂平臺，在這裏遇見與你相同的她。全新推出的靈魂匹配、視頻匹配和多人連麥功能，讓交友更快捷。每日推送新鮮資訊和同好圈內容，有趣好玩的短視頻等你來觀看，動態八卦直播讓你不錯過每一個與她相關的點滴。'
      }
      if (language == '简体中文') {

        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-cn.png'
        this.isEn  = false
      }
      if (language == '繁體中文') {

        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-tw.png'
        this.isEn  = false
      }
      if (language == 'English') {

        this.baiHuaImg = 'https://static.lespark.cn/pc_img/images/baihua/baihua-swiper-en.png'
        this.isEn  = true
      }
    },
    methods: {
      getNum(data) {
        // if (data == 0) {
        //   this.h1Content = '百花计划'
        //   this.h2Content = '拍短视频，享千万补贴'
        // } else if (data == 1) {
        //   this.h1Content = '实时直播'
        //   this.h2Content = '你的声音 甜过初恋'
        // } else if (data == 2) {
        //   this.h1Content = '多人视频'
        //   this.h2Content = '红娘在线 姻缘一线牵'
        // } else if (data == 3) {
        //   this.h1Content = '附近的人'
        //   this.h2Content = '发现你身边的同好圈'
        // } else if (data == 4) {
        //   this.h1Content = '情侣公园'
        //   this.h2Content = '记录相爱点滴'
        // } else if (data == 5) {
        //   this.h1Content = '即时语聊'
        //   this.h2Content = '你的声音 甜过初恋'
        // } else if (data == 6) {
        //   this.h1Content = '快速配对'
        //   this.h2Content = '交友脱单 心动匹配'
        // }

        this.h1Content = this.$t('swiper')[data].h1Content
        this.h2Content = this.$t('swiper')[data].h2Content
      },
      enter(index) {
        const that = this
        that.showList = [false, false, false]
        that.showList[index] = true
      },
      leave() {
        const that = this
        that.showList = [false, false, false]
      },
    },
    computed: {
    },
    watch: {
      attentionMsg(a, b) {
        if (a == 'headerto') {
          bus.$emit('lastAttentionShow', 'yes')
        } else {
          bus.$emit('lastAttentionShow', 'no')
        }
      }
    }
  }
</script>
<style type="text/css" scoped>
.en-size{
  font-size: 70px;
}

.en-width{
  width: 96%;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/home/content/mess.vue